module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-venue-34b214484defd6eaabd6cbe6b4caaad9.jpg";